import { Component, OnInit } from '@angular/core';
import {UtilService} from "../../../shared/services/util.service";
import {MatDialog} from "@angular/material/dialog";
import {Clipboard} from "@angular/cdk/clipboard";
import {DataService} from "../../../shared/services/data.service";
import { MaterialModule } from 'src/app/app.materials';
import { LineChartComponent } from 'src/app/components/line-chart/line-chart.component';
@Component({
  selector: 'app-performance-chart',
  templateUrl: './performance-chart.component.html',
  styleUrls: ['./performance-chart.component.scss'],
  standalone: true,
  imports: [MaterialModule, LineChartComponent]
})
export class PerformanceChartComponent implements OnInit {

  data = {
    drawdownComparison: [
      {id: 688394, date: '2020-01-05', value: 0},
      {id: 688395, date: '2020-01-08', value: -0.02229566},
      {id: 688396, date: '2020-01-09', value: -0.02250603},
      {id: 688397, date: '2020-01-10', value: -0.03218163},
      {id: 688398, date: '2020-01-11', value: -0.03467846},
      {id: 688399, date: '2020-01-12', value: -0.04971979},
      {id: 688400, date: '2020-01-15', value: -0.0509859},
      {id: 688401, date: '2020-01-16', value: -0.06400007},
      {id: 688402, date: '2020-01-17', value: -0.04664418},
      {id: 688403, date: '2020-01-18', value: -0.04574797},
      {id: 688404, date: '2020-01-19', value: -0.04364026},
      {id: 688405, date: '2020-01-22', value: -0.04334351},
      {id: 688406, date: '2020-01-23', value: -0.03793707},
      {id: 688407, date: '2020-01-24', value: -0.03627608},
      {id: 688408, date: '2020-01-25', value: -0.04648493},
      {id: 688409, date: '2020-01-26', value: -0.03119298},
      {id: 688410, date: '2020-01-29', value: -0.03358879},
      {id: 688411, date: '2020-01-30', value: -0.03555112},
      {id: 688412, date: '2020-01-31', value: -0.03407401},
      {id: 688413, date: '2020-02-01', value: -0.02584084},
      {id: 688414, date: '2020-02-02', value: -0.01595808},
      {id: 688415, date: '2020-02-05', value: -0.01433909},
      {id: 688416, date: '2020-02-06', value: -0.01567384},
      {id: 688417, date: '2020-02-07', value: -0.01773496},
      {id: 688418, date: '2020-02-08', value: -0.02682237},
      {id: 688419, date: '2020-02-09', value: -0.03202009},
      {id: 688420, date: '2020-02-12', value: -0.03752934},
      {id: 688421, date: '2020-02-13', value: -0.03752934},
      {id: 688422, date: '2020-02-14', value: -0.03892852},
      {id: 688423, date: '2020-02-15', value: -0.02546945},
      {id: 688424, date: '2020-02-16', value: -0.01587452},
      {id: 688425, date: '2020-02-19', value: -0.01626335},
      {id: 688426, date: '2020-02-20', value: -0.01897325},
      {id: 688427, date: '2020-02-21', value: -0.01018766},
      {id: 688428, date: '2020-02-22', value: -0.01646778},
      {id: 688429, date: '2020-02-23', value: -0.02013536},
      {id: 688430, date: '2020-02-26', value: -0.01104171},
      {id: 688431, date: '2020-02-27', value: -0.01369769},
      {id: 688432, date: '2020-02-28', value: -0.009960172},
      {id: 688433, date: '2020-03-01', value: -0.02301874},
      {id: 688434, date: '2020-03-02', value: -0.02349398},
      {id: 688435, date: '2020-03-05', value: -0.04886579},
      {id: 688436, date: '2020-03-06', value: -0.04713912},
      {id: 688437, date: '2020-03-07', value: -0.03781518},
      {id: 688438, date: '2020-03-08', value: -0.04185469},
      {id: 688439, date: '2020-03-09', value: -0.03855895},
      {id: 688440, date: '2020-03-12', value: -0.0359312},
      {id: 688441, date: '2020-03-13', value: -0.05261673},
      {id: 688442, date: '2020-03-14', value: -0.06064701},
      {id: 688443, date: '2020-03-15', value: -0.06809986},
      {id: 688444, date: '2020-03-16', value: -0.06454073},
      {id: 688445, date: '2020-03-19', value: -0.07285},
      {id: 688446, date: '2020-03-20', value: -0.06382281},
      {id: 688447, date: '2020-03-21', value: -0.06703034},
      {id: 688448, date: '2020-03-22', value: -0.03293891},
      {id: 688449, date: '2020-03-23', value: -0.05798341},
      {id: 688450, date: '2020-03-26', value: -0.0376903},
      {id: 688451, date: '2020-03-27', value: -0.01043443},
      {id: 688452, date: '2020-03-28', value: -0.01104955},
      {id: 688453, date: '2020-03-29', value: -0.004932691},
      {id: 688454, date: '2020-03-30', value: -0.02722134},
      {id: 688455, date: '2020-04-02', value: -0.05482891},
      {id: 688456, date: '2020-04-03', value: -0.06652275},
      {id: 688457, date: '2020-04-04', value: -0.0411914},
      {id: 688458, date: '2020-04-05', value: -0.03922762},
      {id: 688459, date: '2020-04-06', value: -0.03667006},
      {id: 688460, date: '2020-04-09', value: -0.05296352},
      {id: 688461, date: '2020-04-10', value: -0.0540663},
      {id: 688462, date: '2020-04-11', value: -0.04947749},
      {id: 688463, date: '2020-04-12', value: -0.03690179},
      {id: 688464, date: '2020-04-13', value: -0.04013548},
      {id: 688465, date: '2020-04-16', value: -0.04471916},
      {id: 688466, date: '2020-04-17', value: -0.03538476},
      {id: 688467, date: '2020-04-18', value: -0.01522639},
      {id: 688468, date: '2020-04-19', value: -0.00847365},
      {id: 688469, date: '2020-04-20', value: -0.01434433},
      {id: 688470, date: '2020-04-23', value: -0.004270125},
      {id: 688471, date: '2020-04-24', value: -0.002474135},
      {id: 688472, date: '2020-04-25', value: 0},
      {id: 688473, date: '2020-04-26', value: 0},
      {id: 688474, date: '2020-04-27', value: -0.01202073},
      {id: 688475, date: '2020-04-30', value: -0.0100023},
      {id: 688476, date: '2020-05-01', value: 0},
      {id: 688477, date: '2020-05-02', value: 0},
      {id: 688478, date: '2020-05-03', value: 0},
      {id: 688479, date: '2020-05-04', value: 0},
      {id: 688480, date: '2020-05-07', value: 0},
      {id: 688481, date: '2020-05-08', value: -0.008883343},
      {id: 688482, date: '2020-05-09', value: -0.01590123},
      {id: 688483, date: '2020-05-10', value: -0.02322036},
      {id: 688484, date: '2020-05-11', value: -0.02385378},
      {id: 688485, date: '2020-05-14', value: -0.03469046},
      {id: 688486, date: '2020-05-15', value: -0.03226418},
      {id: 688487, date: '2020-05-16', value: -0.03937307},
      {id: 688488, date: '2020-05-17', value: -0.02650243},
      {id: 688489, date: '2020-05-18', value: -0.03017668},
      {id: 688490, date: '2020-05-21', value: -0.02314615},
      {id: 688491, date: '2020-05-22', value: -0.02252235},
      {id: 688492, date: '2020-05-23', value: -0.005061212},
      {id: 688493, date: '2020-05-24', value: -0.002761982},
    ]
  };
  series = [];

  constructor(
    private util: UtilService,
    private dialog: MatDialog,
    private clipboard: Clipboard,
    private service: DataService,
  ) { }

  ngOnInit(): void {
    this.initSeries();
  }

  initSeries(){
    this.series = [];
    const indexSeries = this.util.initSeries(this.data, 'drawdownComparison');
    if (indexSeries) {
      this.series.push(indexSeries);
    }
  }



}
